import type { QualificationLifecycleState } from "@/lib/qualification-lifecycle/types";
import type { GatekeeperPrecisionPair } from "@/types";

export function buildRejectedTransientPrecision(
  state: QualificationLifecycleState
): GatekeeperPrecisionPair | null {
  if (state.phase !== "rejected_transient" || !state.rejectionText?.trim()) {
    return null;
  }
  const questionText = state.questionText.trim();
  if (!questionText) return null;
  return {
    clarification: state.rejectionText.trim(),
    userReply: questionText,
    outcome: "rejected",
    rejectionNotice: state.rejectionNotice?.trim() || undefined,
  };
}
